import { render } from "./ControlPanel.vue?vue&type=template&id=0f6d274a&scoped=true"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"

import "./ControlPanel.vue?vue&type=style&index=0&id=0f6d274a&lang=scss&scoped=true"

import exportComponent from "/Users/tirinox/Projects/thorviz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6d274a"]])

export default __exports__